import ApiService from './ApiService';

export interface PrivacyNoticeDto {
  id: string;
  version: number;
  title: string;
  content: string;
  effectiveAt: string;
  createdAt: string;
  updatedAt: string;
  requiresAcknowledgment: boolean;
  acknowledgedAt: string | null;
}

export interface AcknowledgePrivacyNoticeDto {
  privacyNoticeId: string;
  accepted: boolean;
}

export interface PrivacyNoticeAcknowledgmentDto {
  id: string;
  privacyNoticeId: string;
  userId: string;
  userEmail: string;
  userName: string;
  noticeVersion: number;
  acknowledgedAt: string;
}

export interface CreatePrivacyNoticeDto {
  title: string;
  content: string;
}


export const getPrivacyNotice = async (signal?: AbortSignal): Promise<PrivacyNoticeDto> => {
  return await ApiService.get<PrivacyNoticeDto>({ url: 'privacy-notice', signal });
};

export const acknowledgePrivacyNotice = async (
  data: AcknowledgePrivacyNoticeDto,
  signal?: AbortSignal
): Promise<PrivacyNoticeAcknowledgmentDto> => {
  return await ApiService.post<PrivacyNoticeAcknowledgmentDto, AcknowledgePrivacyNoticeDto>({
    url: 'privacy-notice/acknowledge',
    data,
    signal,
  });
};

export const createPrivacyNotice = async (
  data: CreatePrivacyNoticeDto,
  signal?: AbortSignal
): Promise<PrivacyNoticeDto> => {
  return await ApiService.post<PrivacyNoticeDto, CreatePrivacyNoticeDto>({
    url: 'privacy-notice/admin',
    data,
    signal,
  });
};
